<dx-box width="100%" height="100%" direction="col">
    <dxi-item [ratio]="1">
        <cc-data-grid-features
            [dataSource]="dashboardDetails"
            [gridFeatures]="{
                allowPaging: false,
                allowGrouping: false
            }"
            [pagingConfig]="{
                visible: false
            }"
            [stateConfig]="{
                storageKey: 'USER_DASHBOARD_DETAILS'
            }"
        >
            <dx-data-grid
                #dashboardGrid
                width="100%"
                height="100%"
                class="cc-vertical-center-cell-data-grid"
                [filterSyncEnabled]="true"
                [dataSource]="dashboardDetails"
            >
                <dxi-column dataField="workArea" dataType="string" caption="Work Area"></dxi-column>
                <dxi-column
                    dataField="helpKey"
                    dataType="string"
                    caption="Help"
                    alignment="center"
                    cellTemplate="helpIconTemplate"
                ></dxi-column>
                <dxi-column
                    dataField="status"
                    dataType="string"
                    caption="Status"
                    alignment="center"
                    cellTemplate="statusIconTemplate"
                ></dxi-column>
                <dxi-column dataField="open" dataType="number" caption="Open"></dxi-column>
                <dxi-column dataField="priority" dataType="number" caption="Priority"></dxi-column>
                <dxi-column dataField="problematic" dataType="number" caption="Problematic"></dxi-column>
                <div *dxTemplate="let row of 'helpIconTemplate'" class="help-template-container">
                    <div class="help-icon-content" (click)="onHelpIconClick(row.data)">
                        <i [title]="row.data.helpKey" class="fas fa-question-circle dx-theme-accent-as-text-color"></i>
                    </div>
                </div>
                <div *dxTemplate="let row of 'statusIconTemplate'" class="status-template-container">
                    <div
                        [ngClass]="{
                            'status-icon-big': !row.data.isInfo,
                            'status-icon-small dx-theme-accent-as-background-color': row.data.isInfo
                        }"
                    >
                        <i
                            class="fas"
                            [ngClass]="{
                                'fa-check cc-green-icon': row.data.isOk,
                                'fa-info cc-white-icon': row.data.isInfo,
                                'fa-exclamation-triangle cc-warn-icon': row.data.isPriority,
                                'fa-flag cc-red-icon': row.data.isProblematic
                            }"
                            [title]="row.data.status"
                        ></i>
                    </div>
                </div>
                <dxo-master-detail [enabled]="true" template="masterDetailTemplate"></dxo-master-detail>
                <div *dxTemplate="let row of 'masterDetailTemplate'">
                    <app-user-dashboard-community-details
                        [selectedUser]="selectedUser"
                        [selectedViewOption]="selectedViewOption"
                        [selectedContext]="selectedContext"
                        [workAreaItem]="row.data"
                    ></app-user-dashboard-community-details>
                </div>
            </dx-data-grid>
        </cc-data-grid-features>
    </dxi-item>
</dx-box>
